import { builder } from '@builder.io/react';
import BuilderDefault from '@builder.io/react';

// Domain to locale mapping
const DOMAIN_LOCALE_MAP = {
  'ridley-bikes.cz': 'cs',
  'ridley-bike.pl': 'pl',
  'ridley-bikes.sk': 'sk',
  'ridley-bikes.hu': 'hu',
  'ridley-cz.llw.cz': 'cs',
  'ridley-pl.llw.cz': 'pl',
  'ridley-sk.llw.cz': 'sk',
  'ridley-hu.llw.cz': 'hu',
  'localhost': 'cs',
  '127.0.0.1': 'cs',
  'www.ridley-bikes.cz': 'cs',
  'www.ridley-bike.pl': 'pl',
  'www.ridley-bikes.sk': 'sk',
  'www.ridley-bikes.hu': 'hu'
};

// Get current locale based on domain
const getCurrentLocale = () => {
  try {
    const hostname = window.location.hostname;
    
    // Check for exact domain match
    if (DOMAIN_LOCALE_MAP[hostname]) {
      return DOMAIN_LOCALE_MAP[hostname];
    }
    
    // Check for subdomain matches (in case of www.ridley-bikes.cz etc.)
    for (const [domain, locale] of Object.entries(DOMAIN_LOCALE_MAP)) {
      if (hostname.includes(domain)) {
        return locale;
      }
    }
    
    // Default to Czech if no match found (primary domain)
    return 'cs';
  } catch (error) {
    return 'cs'; // fallback to Czech
  }
};

// Patch both named and default exports
const patchBuilderGet = (builderInstance, name) => {
  if (builderInstance && builderInstance.get) {
    const originalGet = builderInstance.get.bind(builderInstance);
    builderInstance.get = (modelName, options = {}) => {
      const locale = getCurrentLocale();
      
      return originalGet(modelName, {
        locale,
        ...options
      });
    };
  } else {
  }
};

// Patch named export
patchBuilderGet(builder, 'named export');

// Patch default export
patchBuilderGet(BuilderDefault, 'default export');

// Also patch the .default property if it exists
if (BuilderDefault && BuilderDefault.default) {
  patchBuilderGet(BuilderDefault.default, 'default.default export');
}


// Export the current locale function for use in other components if needed
export { getCurrentLocale };

// Export the patched builder (optional, for explicit imports)
export default BuilderDefault || builder;
